/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { SnsAccount } from './sns-account';

/**
 * 
 * @export
 * @interface ViewupPlusSnsAccount
 */
export interface ViewupPlusSnsAccount {
    /**
     * 리그램 여부
     * @type {boolean}
     * @memberof ViewupPlusSnsAccount
     */
    'isRegram'?: boolean;
    /**
     * 승인 상태
     * @type {string}
     * @memberof ViewupPlusSnsAccount
     */
    'approvalStatus': ViewupPlusSnsAccountApprovalStatusEnum;
    /**
     * sns 계정
     * @type {SnsAccount}
     * @memberof ViewupPlusSnsAccount
     */
    'snsAccount': SnsAccount;
}

export const ViewupPlusSnsAccountApprovalStatusEnum = {
    Pending: 'pending',
    Waiting: 'waiting',
    Approved: 'approved',
    Rejected: 'rejected'
} as const;

export type ViewupPlusSnsAccountApprovalStatusEnum = typeof ViewupPlusSnsAccountApprovalStatusEnum[keyof typeof ViewupPlusSnsAccountApprovalStatusEnum];


